import { userParams } from '../user/paramConfig';
const navParams = {
    paramMapping: userParams,
};

export { navParams };
